// extracted by mini-css-extract-plugin
export default {"container":"_3nuBz4u3i8b8T1juLWmPEz","subheader":"_2keCTIIkKjRXXu5W6fwIG5","alternativeSiteLink":"_6i1lD7oVBc5WxL9LH3w1DB","separator":"_5Nt1Rra9kPjbQCxAfMkGx1"};